import React from "react";
import "../Mission/Mission.css";

const VisionMissionSection = () => {
  return (
    <section className="vm-section">
      <div className="vm-wrapper">
        <div className="vm-left">
          <div className="vm-card vision-card">
            <div className="vm-icon-circle">
              <img
                src="https://cdn-icons-png.flaticon.com/512/709/709586.png"
                alt="Vision Icon"
              />
            </div>
            <h3>Our Vision</h3>
            <p>
              To be the global leader in orthopedic instruments packaging by
              setting benchmarks in innovation, safety, and
              sustainability—ensuring every product is delivered with
              uncompromised protection and precision.
            </p>
          </div>

          <div className="vm-card mission-card">
            <div className="vm-icon-circle dark">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3176/3176297.png"
                alt="Mission Icon"
              />
            </div>
            <h3>Our Mission</h3>
            <p>
              To design and manufacture advanced packaging solutions that
              safeguard orthopedic tools, enhance sterility, and support
              healthcare professionals with reliable, efficient, and compliant
              packaging systems.
            </p>
          </div>
        </div>

        <div className="vm-right">
          <h2>Excellence In Orthopedic Packaging</h2>
          <p>
            We specialize in precision-engineered packaging solutions tailored
            for orthopedic instruments. Our commitment lies in quality,
            compliance, and innovation, helping medical device manufacturers
            deliver with confidence and care.
          </p>
          <div className="vm-divider" />
          <p className="partners-label">Our Partners:</p>
          <div className="partners-logos">
            <img src="logo.webp" alt="Partner logo 1" />
            <img src="logo.webp" alt="Partner logo 2" />
            <img src="logo.webp" alt="Partner logo 3" />
            <img src="logo.webp" alt="Partner logo 4" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionSection;
